import { defineMessages } from "react-intl";

import type { Traveller } from "@/features/travellers/types/types";

export const titleOptions: Traveller["title"][] = [
  "mr",
  "mrs",
  "miss",
  "mstr",
] as const;

export const travellerTitleMessages = defineMessages<Traveller["title"]>({
  mr: {
    defaultMessage: "Mr",
    description: "Traveller title option: Mr",
  },
  mrs: {
    defaultMessage: "Mrs",
    description: "Traveller title option: Mrs",
  },
  miss: {
    defaultMessage: "Miss",
    description: "Traveller title option: Miss",
  },
  mstr: {
    defaultMessage: "Mstr",
    description:
      "Traveller title option: Master (used for young male travellers)",
  },
  ms: {
    defaultMessage: "Ms",
    description:
      "Traveller title option: Ms (used for women that does not indicate marital status)",
  },
});
